import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '@core/services/loading.service';
import { finalize } from 'rxjs';
import { SKIP_SPINNER } from './skip-spinner.token';

let activeRequests = 0;

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {

    const spinnerService = inject(LoadingService);

    if (req.context.get(SKIP_SPINNER)) {
        return next(req);
    }

    activeRequests++;
    if (activeRequests === 1) {
        spinnerService.show();
    }

    return next(req).pipe(
        finalize(() => {
            activeRequests--;
            if (activeRequests === 0) {
                spinnerService.hide();
            }
        })
    );
};
